module.exports = EventManager;


//////////////////
// WEBPACK FOOTER
// external "EventManager"
// module id = 16
// module chunks = 1